// THE CALM APP GLYPH — one neutral plate with the app's glyph in title ink:
// the home App strip's tile (components/HomeAppStrip.js) and the search
// dropdown's app tiles (components/SearchAppsMenu.js) wear the same one, so an
// app looks the same wherever it is offered (9A — Nika 2026-09-28: "improve
// icons design"; the picks page: "calm glyph tiles instead of bright
// gradients").
//
// Neutral by construction: the `layer` theme (the house wash of the ground,
// both schemes) and `title` ink — no per-app hue, no gradient squircle. The
// hover and press of the tile belong to the control that holds it (the strip
// item, the launcher tile), which steps this plate's wash; the plate declares
// the transition those steps ride.
//
//   AppGlyphTile: {}                    — the glyph reads `s.icon`
//   AppGlyphTile: { Icon: { name: … } } — or a caller names it
export const AppGlyphTile = {
  theme: 'layer',
  color: 'title',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: '0',
  boxSize: 'controlH',
  minWidth: 'controlH',
  round: 'radiusControl',
  transition: 'background-color A defaultBezier, transform Z defaultBezier',
  Icon: {
    name: (el, s) => (s && s.icon) || 'star',
    boxSize: 'iconMd'
  }
}

// THE GLYPH PLATE of the new glyph language moved to the shared kit (shared/components/AppGlyphPlate.js): the
// navbar tabs are shared code and wear it too (dropdowns spec 2026-09-30 §12).
